import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import tokens from '../../design/tokens'

export const SPACING_2 = '2'
export const SPACING_4 = '4'
export const SPACING_8 = '8'
export const SPACING_16 = '16'
export const SPACING_24 = '24'
export const SPACING_32 = '32'
export const SPACING_40 = '40'

const handleVariant = ({ variant }) => {
  switch (variant) {
    case SPACING_40:
      return `
        height: ${tokens.spacing.baseN * 5}px;
      `
    case SPACING_32:
      return `
        height: ${tokens.spacing.baseN * 4}px;
      `
    case SPACING_24:
      return `
        height: ${tokens.spacing.baseN * 3}px;
      `

    case SPACING_16:
      return `
        height: ${tokens.spacing.baseN * 2}px;
      `
    case SPACING_8:
      return `
        height: ${tokens.spacing.baseN}px;
      `

    case SPACING_4:
      return `
        height: ${tokens.spacing.baseN / 2}px;
      `

    case SPACING_2:
      return `
          height: ${tokens.spacing.baseN / 4}px;
        `
  }
}

const StyledSpacing = styled.div`
  ${handleVariant}
`

export const SpacingVertical = ({ className, variant, ...other }) => {
  return <StyledSpacing className={className} variant={variant} {...other} />
}

SpacingVertical.defaultProps = {
  variant: SPACING_24
}

SpacingVertical.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    SPACING_2,
    SPACING_4,
    SPACING_8,
    SPACING_16,
    SPACING_24,
    SPACING_32,
    SPACING_40
  ])
}
